import { Component, OnInit,ViewChild } from '@angular/core';
import { DatabaseGetterService } from '../database-getter.service';
import {SafePipe} from '../SafePipe';
import { User } from '../User';
import { ReCaptchaComponent } from 'angular2-recaptcha';
@Component({
  selector: 'app-fullpage',
  templateUrl: './fullpage.component.html',
  styleUrls: ['./fullpage.component.css']
})
export class FullpageComponent implements OnInit {
  @ViewChild(ReCaptchaComponent,{static: false}) captcha: ReCaptchaComponent;
  public successMessage:string;
  constructor(private _databaseService:DatabaseGetterService) { }
  ngOnInit() {
    this._databaseService.getYoutubeVideos();
  }
  submitEmail(email){
    if(!this.captcha.getResponse())
      return;
    this._databaseService.captcha = this.captcha.getResponse();
    this._databaseService.registerUser(new User("alphaemail","",email));
    this.successMessage = "You've successfully subscribed to eligible to become a tester for Apocalypse Simulator";
  }
}
